import React, { ChangeEvent } from 'react';
import { TableRow, TextField } from '@material-ui/core';

import { NoBorderCell } from 'components/common/table/TableStyle';

import { BoldText } from '../ModalContent.styled';
import { CouponFormField } from 'types/member';

interface Props {
  couponDescription: string;
  onChangeValue: (event: ChangeEvent<HTMLInputElement>) => void;
}

const CouponCode = ({ couponDescription, onChangeValue }: Props) => {
  return (
    <TableRow>
      <NoBorderCell>
        <BoldText>Coupon Code</BoldText>
      </NoBorderCell>
      <NoBorderCell>
        <TextField
          fullWidth
          multiline
          rows={5}
          value={couponDescription}
          onChange={onChangeValue}
          name={CouponFormField.DESCRIPTION}
          variant={'outlined'}
          placeholder={'Please enter the coupon code name. \nThis will be shown to users.'}
          inputProps={{
            maxLength: 250,
          }}
        />
      </NoBorderCell>
    </TableRow>
  );
};

export default CouponCode;
